/**
 * Skeleton loading primitives for admin panels.
 * Shimmer is defined in App.css (.skeleton class).
 */
export function SkeletonLine({ w = "100%", h = 14, className = "" }) {
  return <div className={`skeleton ${className}`} style={{ width: w, height: h }} />;
}

export function SkeletonBlock({ h = 80, className = "" }) {
  return <div className={`skeleton ${className}`} style={{ height: h, width: "100%" }} />;
}

export function SkeletonRow() {
  return (
    <div className="border border-white/5 bg-[#111] p-4 sm:p-5 space-y-3" data-testid="skeleton-row">
      <div className="flex items-center gap-3">
        <SkeletonLine w={80} h={10} />
        <SkeletonLine w={60} h={10} />
        <SkeletonLine w={40} h={10} />
      </div>
      <SkeletonLine w="70%" h={18} />
      <SkeletonLine w="95%" h={12} />
      <SkeletonLine w="40%" h={12} />
    </div>
  );
}

export function SkeletonList({ count = 4 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => <SkeletonRow key={i} />)}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="border border-white/5 bg-[#111] p-5 space-y-3">
      <SkeletonLine w="40%" h={10} />
      <SkeletonLine w="80%" h={28} />
      <SkeletonLine w="60%" h={12} />
    </div>
  );
}

export function SkeletonStatsGrid({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
  );
}
